/**
 * Prüf-Chat CP-018 (02.11.2026): Links zu Beiträgen kopiert man oft ohne „https://“ („instagram.com/reel/…“). Statt sie
 * abzulehnen, ergänzen wir das Schema, wenn der Text wie eine Adresse aussieht (Name mit Punkt und Endung, ohne Leerzeichen).
 * Alles andere bleibt, wie es ist, und wird von der Prüfung abgelehnt.
 */
export function mitSchema(text: string): string {
  const s = text.trim();
  if (!s || /^https?:\/\//i.test(s)) return s;
  if (/^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}(\/\S*)?$/i.test(s)) return `https://${s}`;
  return s;
}

/** Gültiger Beitragslink (nach dem Ergänzen): http(s) ohne Leerzeichen */
export function beitragslinkGueltig(text: string): boolean {
  return /^https?:\/\/\S+$/i.test(mitSchema(text));
}
